module.exports = __webpack_public_path__ + "img/confirm-demo.3749d56.png";